<template>
  <div v-if="entries?.length > 0" class="c-startpage-hero-template-tablet carousel hero-tablet option-line-bullets">
    <template v-if="entries.length == 1">
      <template v-for="entry in entries" :key="entry">
        <template v-if="entry.type == 'Primary'">
          <StartpageHeroElementBannerSimple :entry="entry" />
        </template>
        <template v-if="entry.type == 'Secondary'">
          <StartpageHeroElementBannerDetailed :entry="entry" />
        </template>
      </template>
    </template>
    <template v-if="entries.length > 1">
      <NuxtCarousel v-bind="carouselConfig" class="hero-tablet-carousel">
        <NuxtSlide v-for="entry in entries" :key="entry.priority">
          <template v-if="entry.type == 'Primary'">
            <StartpageHeroElementBannerSimple :entry="entry" />
          </template>
          <template v-if="entry.type == 'Secondary'">
            <StartpageHeroElementBannerDetailed :entry="entry" />
          </template>
        </NuxtSlide>
        <template #addons>
          <NuxtNavigation />
          <NuxtPagination />
        </template>
      </NuxtCarousel>
    </template>
  </div>
</template>
<script setup lang="ts">
import { useMutationObserver } from "@vueuse/core";
import type { SliderEntry } from '../SliderStructure';

defineProps<{
  entries: SliderEntry[];
}>();

const slider = useTemplateRef('slider');
const carouselConfig = {
  itemsToShow: 1,
  gap: 24,
  breakpointMode: 'carousel',
  paginateByItemsToShow: true,
  wrapAround: true,
  autoplay: 3500,
  pauseAutoplayOnHover: true,
} as const;
useMutationObserver(slider, (mutations) => {
  for (const mutation of mutations) {
    if (mutation.type === 'attributes') {
      setTabIndex(mutation.target as HTMLBodyElement, mutation.oldValue === 'true' ? 0 : -1);
    }
  }
}, {
  attributes: true,
  attributeFilter: ['aria-hidden'],
  attributeOldValue: true,
  subtree: true,
});


const setTabIndex = (element: HTMLBodyElement, tabIndex: number): void => {
  element.tabIndex = tabIndex;
  const children = element.querySelectorAll('a');
  for (const child of children) {
    child.tabIndex = tabIndex;
  }
};
</script>

<style scoped lang="postcss"> 
  .hero-tablet-carousel :deep( .carousel__viewport) { 
    @apply rounded-3xl; 
  } 
</style>